import React from 'react';

export default function BnplConfirmed({ className }) {
  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <h1>Financing confirmed and accepted</h1>
      </div>
      <div className={`${className}__divider`} />
      <div className={`${className}__payment-description`}>
        <p>
          Thank you for choosing L-pay. To complete your purchase today, please confirm with your
          sales representative that L-pay is selected as a payment option in your shopping cart. If
          a down payment is required, then it should be paid directly to the merchant.
        </p>
      </div>
    </div>
  );
}
